import React, { useEffect, useMemo, useRef } from "react";
import { notification, Select, Spin } from "antd";
import { GoogleMap } from "../Common";
import Filters from "../Home/Filters";
import { has, isEmpty, pick } from "lodash";
import userServices from "../../UserServices/UserServices";
import { DataService, TenantService } from "../../Services";
import { HomeContext } from "../Context";
import { formateString } from "../Common/Functions";
import { Container as ReactContainer, Row as ReactRow, Col as ReactCol, Card as ReactCard } from "reactstrap";
import { MainNavbar } from "../Core";
import { Functions } from "../Common";
import { Constant } from "../Common";
import { setMyConfig } from "../../Services/auth";
import { useNavigate } from "react-router-dom";
import { LANDING_PAGE } from "../../Services/routesService";

/**
 * Maps each numeric value in `data` to an HSL red shade.
 * Higher values → darker red; lower values → lighter red.
 *
 * @param {Object.<string, number>} data
 * @returns {Object.<string, string>}
 */
function mapValuesToRedShades(data) {
	const entries = Object.entries(data);
	const values = entries.map(([, v]) => v);

	const min = Math.min(...values);
	const max = Math.max(...values);
	// prevent division by zero
	const range = max - min || 1;

	return entries.reduce((acc, [key, value]) => {
		// normalize to 0–1
		const ratio = (value - min) / range;
		// lightness goes from 80% (light) down to 20% (dark)
		const lightness = 80 - ratio * 60;
		acc[key] = `hsl(0, 100%, ${lightness.toFixed(1)}%)`;
		return acc;
	}, {});
}

const { defaultFilters, variables, getClientandTenantFilter } = Constant;

const AREA_TYPE = "STATE";
const { getPolygon, FindCenter, FormateNumber, modifyFilterObjectForQuery } = Functions;

const screenRatio = 1.7778;
const heightFactor1 = 0.6; //0.59;
const mapHeight = Math.floor((window.innerWidth / screenRatio) * heightFactor1);

export const LandingPage = () => {
	const navigate = useNavigate();

	const { tenant } = useMemo(() => {
		const { tenant } = pick(userServices.getCurrentUser(), ["tenant"]);

		return { tenant };
	}, []);

	useEffect(() => {
		if (tenant !== "BAT_STATES") {
			navigate(`${LANDING_PAGE}`);
		}
	}, [tenant, navigate]);
	const [statesData, setStatesData] = React.useState([]);
	const [selectedState, setSelectedState] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [allPolygons, setAllPolygons] = React.useState([]);
	const [center, setCenter] = React.useState({ lng: -109.048455, lat: 40.82608099906653 });
	const [selectedIds, setSelectedIds] = React.useState([]);
	const [stateCounts, setStateCounts] = React.useState({});
	const [counts, setCounts] = React.useState({
		censusShops: 0,
		selectedOutlets: 0,
		batStates: 0,
		batStatesSelected: 0,
		batContractedOutlets: 0,
		batContractedOutletsSelected: 0
	});
	const [countLoading, setCountLoading] = React.useState({
		censusShops: false,
		selectedOutlets: false,
		batStates: false,
		batStatesSelected: false,
		batContractedOutlets: false,
		batContractedOutletsSelected: false,
		tenantFiltersLoading: false
	});

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				// getUserPolygonsOfArea from dataService
				const response = await DataService.getUserPolygonsOfArea({ areaType: AREA_TYPE });
				if (response && response.data) {
					const dataForSelect = response.data.map(item => ({
						label: item.name,
						value: item._id
					}));
					const allPolygonsData = [];
					response.data.forEach(item => {
						const polygon = getPolygon({
							_id: item._id,
							coordinates: item.boundary.coordinates,
							// center: {
							// 	lng: item.center.coordinates[0],
							// 	lat: item.center.coordinates[1]
							// },
							center: item.center.coordinates,
							sub_areas: [],
							type: "STATE",
							parent_area: "",
							name: item.name
						});
						allPolygonsData.push(polygon);
					});
					const allIds = allPolygonsData.map(polygon => polygon._id);
					const center = FindCenter(Object.values(allPolygonsData).map(({ center }) => center));
					setCenter(center);

					setAllPolygons(allPolygonsData);
					setStatesData(dataForSelect);
					setSelectedIds(allIds);
					setSelectedState(dataForSelect.map(state => state.value)); // Set the first state as default
					setLoading(false);

					// Process the fetched data as needed
				} else {
					setLoading(false);
					console.error("No data found");
				}
			} catch (error) {
				setLoading(false);
				console.error("Error fetching data:", error);
			}
		};

		const fetchTotalCensusCount = async () => {
			setCountLoading(prev => ({ ...prev, censusShops: true }));
			const countsResults = await DataService.fetchCensusCount({
				type: AREA_TYPE
			});
			const response = countsResults.data;
			setStateCounts(response);
			const censusShopsCount = Object.values(response).reduce((acc, curr) => acc + (curr || 0), 0);

			setCounts(prevCounts => ({
				...prevCounts,
				censusShops: censusShopsCount
			}));
			setCountLoading(prev => ({ ...prev, censusShops: false }));
		};
		// fetchCensusCount
		const fetchTotalOutletCount = async () => {
			setCountLoading(prev => ({ ...prev, batStates: true }));
			const countsResults = await DataService.fetchOutletCount({
				type: AREA_TYPE
				// filters: JSON.stringify({ tenant })
			});
			const response = countsResults.data;
			const selectedOutletsCount = Object.values(response).reduce((acc, curr) => acc + (curr || 0), 0);

			setCounts(prevCounts => ({
				...prevCounts,
				batStates: selectedOutletsCount
			}));
			setCountLoading(prev => ({ ...prev, batStates: false }));
		};

		const fetchTotalContractedOutletCount = async () => {
			setCountLoading(prev => ({ ...prev, batContractedOutlets: true }));
			let Filters = {};

			if (has(defaultFilters, `${tenant}-${variables.bat_contracted_outlets}`)) {
				Filters = {
					...Filters,
					...defaultFilters[`${tenant}-${variables.bat_contracted_outlets}`]
				};
			}

			const { data: resultdata } = await DataService.fetchOutletCount({
				type: AREA_TYPE,
				Filters
			});
			const count = Object.values(resultdata).reduce((acc, curr) => acc + (curr || 0), 0);

			setCounts(prevCounts => ({
				...prevCounts,
				batContractedOutlets: count
			}));
			setCountLoading(prev => ({ ...prev, batContractedOutlets: false }));
		};

		const fetchTenantConfig = async () => {
			setCountLoading(prev => ({ ...prev, tenantFiltersLoading: true }));

			const { data } = await TenantService.getMyConfig();
			setMyConfig(
				data?.permissions || [],
				data?.censusReportColumns || [],
				data?.clientReportColumns || [],
				data?.filters || [],
				data?.censusShopCardData || [],
				data?.clientShopCardData || [],
				data?.secDifination || []
			);
			setCountLoading(prev => ({ ...prev, tenantFiltersLoading: false }));
		};
		fetchTenantConfig();
		fetchTotalContractedOutletCount();

		fetchTotalOutletCount();
		fetchTotalCensusCount();
		fetchData();
	}, []);
	const coloredRef = useRef(false);
	useEffect(() => {
		// guard: no data or already colored
		if (!allPolygons?.length || isEmpty(stateCounts) || coloredRef.current) {
			return;
		}

		const shades = mapValuesToRedShades(stateCounts);

		// functional update so we don’t need allPolygons in deps
		setAllPolygons(prev =>
			prev.map(polygon => {
				const fillColor = shades[polygon._id] ?? "#8ccdfc96";
				return {
					...polygon,
					style: {
						...polygon.style,
						fillColor
					}
				};
			})
		);

		// mark as done so this effect never runs again for this stateCounts
		coloredRef.current = true;
	}, [stateCounts]); // <-- only re-runs when stateCounts changes

	return (
		<ReactContainer
			fluid
			className="px-0"
			style={{ backgroundColor: "#f1f1f1", overflowX: "hidden", height: "calc(100vh - 0px)" }}
		>
			<MainNavbar />
			<ReactRow className="r1 pl-3 pt-3">
				<ReactCol lg={12} md={12} sm={12} className="r1 px-2">
					<div className="d-flex mt-3 px-0">
						<div className="d-flex col-lg-3 col-md-6 col-sm-12 pl-0">
							<div>
								<h6 className="mr-2 pt-2">{formateString("STATE")}</h6>
							</div>
							<div className="w-100">
								<Select
									disabled
									maxTagCount={3}
									mode="multiple"
									style={{ width: "100%" }}
									value={selectedState}
									onChange={value => {
										setSelectedState(value);
									}}
								>
									{statesData.map((state, index) => (
										<Select.Option key={index} value={state.value}>
											{state.label}
										</Select.Option>
									))}
								</Select>
							</div>
						</div>
					</div>
				</ReactCol>
			</ReactRow>

			<ReactRow className="r4 mt-2 h-100 pt-3">
				<ReactCol lg={8} md={12} sm={12} className="mb-3 mb-lg-0 pl-4 pr-2">
					<ReactCard className="shadow h-100Px">
						<Spin spinning={loading}>
							<GoogleMap
								polygons={allPolygons}
								center={center}
								zoomToPolygon
								handlePolygonClick={({ _id }) => {
									if (_id) {
										const url = `${LANDING_PAGE}/${_id}`;
										window.open(url, "_blank", "noopener,noreferrer");

										// navigate(`${LANDING_PAGE}/${_id}`);
									}
									// /home
									console.log("polygon clicked", _id);
								}}
							/>
						</Spin>
					</ReactCard>
				</ReactCol>

				<ReactCol lg={4} md={12} sm={12} className=" mob-view-filter  pl-2 pr-4">
					<ReactCard className="h-100Px shadow">
						<HomeContext.Provider
							value={{
								tenant,
								loadingsData: {},
								downloadReport: async ({
									Filters,
									onDownloadProgress,
									cancelToken,
									targetKeys,
									email,
									emailReport
								}) => {
									let { censusFilter } = getClientandTenantFilter(Filters);
									censusFilter = modifyFilterObjectForQuery(censusFilter);

									const res = await DataService.downloadReport({
										Filters: censusFilter,
										selectedTypeIds: selectedIds,
										onDownloadProgress,
										cancelToken,
										targetKeys,
										selectedType: AREA_TYPE,
										filterData: {},
										sliderValue: {},
										email,
										emailReport
									});
									if (res.status === 200) {
										notification.success({
											message: "Download started",
											description:
												"Your report is being prepared and  will Sent to your email once ready."
										});
									}
								},
								FilterShops: async Filters => {
									const { censusFilter, tenantFilter } = getClientandTenantFilter(Filters);

									const filterCensusShops = async () => {
										setCountLoading(prev => ({ ...prev, selectedOutlets: true }));

										const filteredCount = await DataService.applyFilter({
											Filters: censusFilter,
											selectedTypeIds: selectedIds,
											selectedType: AREA_TYPE,
											filterData: {},
											sliderValue: {}
										});
										const { data: selectedOutlets } = filteredCount;

										setCounts(prevCounts => ({
											...prevCounts,
											selectedOutlets: selectedOutlets
										}));
										setCountLoading(prev => ({ ...prev, selectedOutlets: false }));
									};

									const filterClinetShops = async () => {
										setCountLoading(prev => ({ ...prev, batStatesSelected: true }));

										const filteredCount = await DataService.applyClientFilter({
											Filters: tenantFilter,
											selectedTypeIds: selectedIds,
											selectedType: AREA_TYPE,
											filterData: {},
											sliderValue: {}
										});
										const { data: selectedOutlets } = filteredCount;

										setCounts(prevCounts => ({
											...prevCounts,
											batStatesSelected: selectedOutlets
										}));
										setCountLoading(prev => ({ ...prev, batStatesSelected: false }));
									};
									const filterClinetContractedShops = async () => {
										setCountLoading(prev => ({ ...prev, batContractedOutletsSelected: true }));
										let Filters = {};
										if (has(defaultFilters, `${tenant}-${variables.bat_contracted_outlets}`)) {
											Filters = {
												...Filters,
												...defaultFilters[`${tenant}-${variables.bat_contracted_outlets}`]
											};
										}
										const filteredCount = await DataService.applyClientFilter({
											Filters: {
												...tenantFilter,
												...Filters
											},
											selectedTypeIds: selectedIds,
											selectedType: AREA_TYPE,
											filterData: {},
											sliderValue: {}
										});
										const { data: selectedOutlets } = filteredCount;

										setCounts(prevCounts => ({
											...prevCounts,
											batContractedOutletsSelected: selectedOutlets
										}));
										setCountLoading(prev => ({ ...prev, batContractedOutletsSelected: false }));
									};

									filterClinetContractedShops();
									filterClinetShops();
									filterCensusShops();
								},
								dispatch: () => {}
							}}
						>
							<div
								className="scroll-area-lg1 scrollableListingsX   sec-wise"
								style={{ overflowY: "auto", height: mapHeight }}
							>
								<Spin spinning={loading}>
									{countLoading.tenantFiltersLoading && <Spin className="mt-5" size="large" />}
									{!countLoading.tenantFiltersLoading && (
										<Filters
											page="landingPage"
											loadingsData={{}}
											_tenant={tenant}
											homeDispatch={() => {}}
											resetShopsCounts={() => {
												setCounts(prevCounts => ({
													...prevCounts,
													selectedOutlets: 0,
													batStatesSelected: 0,
													batContractedOutletsSelected: 0
												}));
											}}
										>
											{[
												<div style={{ width: "100%" }} className="cardshadow">
													<table
														className="table table-striped table-borderedX table-hover mb-0"
														style={{ width: "100%" }}
													>
														<tr className="bg-blue shadow">
															<th className="elipsisx">Stats</th>
															<th className="elipsisx "></th>
														</tr>
														<tr className="main-tbl-bg">
															<th className="elipsisx">Census Shops</th>
															<th className="elipsisx ">
																{countLoading.censusShops ? (
																	<Spin size="small" />
																) : (
																	FormateNumber(counts.censusShops)
																)}
															</th>
														</tr>
														<tr>
															<th className="elipsisx">Selected Outlets</th>
															<th className="elipsisx ">
																{countLoading.selectedOutlets ? (
																	<Spin size="small" />
																) : (
																	FormateNumber(counts.selectedOutlets)
																)}
															</th>
														</tr>
														<tr className="main-tbl-bg">
															<th className="elipsisx">TDLinx Outlets </th>
															<th className="elipsisx ">
																{countLoading.batStates ? (
																	<Spin size="small" />
																) : (
																	FormateNumber(counts.batStates)
																)}
															</th>
														</tr>
														<tr>
															<th className="elipsisx">TDLinx Outlets Selected </th>
															<th className="elipsisx ">
																{countLoading.batStatesSelected ? (
																	<Spin size="small" />
																) : (
																	FormateNumber(counts.batStatesSelected)
																)}
															</th>
														</tr>
														<tr className="main-tbl-bg">
															<th className="elipsisx">BAT Contracted Outlets </th>
															<th className="elipsisx ">
																{countLoading.batContractedOutlets ? (
																	<Spin size="small" />
																) : (
																	FormateNumber(counts.batContractedOutlets)
																)}
															</th>
														</tr>
														<tr>
															<th className="elipsisx">
																BAT Contracted Outlets Selected{" "}
															</th>
															<th className="elipsisx ">
																{countLoading.batContractedOutletsSelected ? (
																	<Spin size="small" />
																) : (
																	FormateNumber(counts.batContractedOutletsSelected)
																)}
															</th>
														</tr>
													</table>
												</div>
											]}
										</Filters>
									)}
								</Spin>
							</div>
						</HomeContext.Provider>
					</ReactCard>
				</ReactCol>
			</ReactRow>
		</ReactContainer>
	);
};

export default LandingPage;
